export function slugify (text: string): string {
	return text
		.toLowerCase()
		.replace(/ /g, "-")
		.replace(/_/g, "-")
		.replace(/[^a-z0-9-]/g, "");
}
